import { cn } from "@/lib/utils";

type FooterPanelProps = React.HTMLAttributes<HTMLDivElement>;

export function FooterPanel({ children, className }: FooterPanelProps) {
	return <div className={cn(className, "asio-footer-panel")}>{children}</div>;
}
